/**
 * Переключатель канала (§2.3 «<ChannelSwitch>», §4.6, П7).
 *
 * Два сегмента по 92 px и подпись-число справа. Число приходит готовой строкой
 * («230 брендов»): склонение живёт в словаре текстов рядом с `plural()`
 * (§12.1), а не в контроле.
 *
 * Сохранение фильтров, сортировки, скролла и курсора при переключении — забота
 * экрана таблицы (§2.3): контрол только сообщает новый канал.
 */
import type { ChannelCode } from '@shared/types.ts'
import { SegmentedControl } from './SegmentedControl'
import './ChannelSwitch.css'

export interface ChannelSwitchProps {
  value: ChannelCode
  onChange: (channel: ChannelCode) => void
  /** Готовая подпись справа: «230 брендов». Склонение — в текстах (§12.1). */
  caption?: string
  /** Подписи сегментов. Значения по умолчанию — из §2.3. */
  labels?: Record<ChannelCode, string>
  /** Доступное имя группы. */
  label?: string
  /** Подписи капсом: канал — режим работы, а не обычная кнопка. */
  caps?: boolean
  className?: string
}

/** Ширина половины сегмента, §2.3. */
const SEGMENT_WIDTH = 92

export function ChannelSwitch({
  value,
  onChange,
  caption,
  labels = { retail: 'Розница', b2b: 'Опт' },
  label = 'Канал',
  caps = false,
  className,
}: ChannelSwitchProps) {
  const classes = ['channel-switch']
  if (caps) classes.push('channel-switch--caps')
  if (className) classes.push(className)

  return (
    <div className={classes.join(' ')}>
      <SegmentedControl<ChannelCode>
        value={value}
        onChange={onChange}
        label={label}
        segmentWidth={SEGMENT_WIDTH}
        options={[
          { value: 'retail', label: labels.retail },
          { value: 'b2b', label: labels.b2b },
        ]}
      />
      {caption ? (
        <span className="channel-switch__caption t-meta" aria-live="polite">
          {caption}
        </span>
      ) : null}
    </div>
  )
}
